import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=5b82f4d6&scoped=true"
import script from "./InfoIcon.vue?vue&type=script&lang=js"
export * from "./InfoIcon.vue?vue&type=script&lang=js"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=5b82f4d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82f4d6",
  null
  
)

export default component.exports